var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98298 13.3457C4.11536 13.3457 0.8125 13.9305 0.8125 16.2724C0.8125 18.6143 4.0944 19.22 7.98298 19.22C11.8506 19.22 15.1525 18.6343 15.1525 16.2933C15.1525 13.9524 11.8715 13.3457 7.98298 13.3457Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98294 10.0059C10.521 10.0059 12.5782 7.94779 12.5782 5.40969C12.5782 2.8716 10.521 0.814453 7.98294 0.814453C5.44484 0.814453 3.38675 2.8716 3.38675 5.40969C3.37817 7.93922 5.42198 9.99731 7.95056 10.0059H7.98294Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.14ec6ae77b0f902a827324acb0ec0272.svg";
export { ForwardRef as ReactComponent };